import { ApiResponse } from "models";
import { CouponUsagePayload } from "models/couponUsage";
import axiosClient from "./axiosClient";

const couponUsageApi = {
  getCouponUsage(data: CouponUsagePayload): Promise<ApiResponse> {
    const url = `/couponManage/getAllCouponUsageData?limit=${
      data.limit || ""
    }&page=${data.page || ""}&search=${data.search || ""}&sortField=${
      data.sortName || ""
    }&sortType=${data.sortType || ""}`;
    return axiosClient.get(url);
  },
};

export default couponUsageApi;
